import { createContext } from 'utils/react-helpers';

export default createContext({
  name: 'DashboardContext',
});
